var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 12.375c2.078 0 3.375-.774 3.375-4.5V0h2.25v7.875c0 4.975-2.412 6.75-5.613 6.75-3.201 0-5.637-1.775-5.637-6.75V0h2.25v7.875c0 3.726 1.32 4.5 3.375 4.5Zm5.625 3.375H3.442V18h11.183v-2.25Z"
})));
export default SvgIconUnderline;